import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const ProtectedRoute = ({ children, requiredRole }) => {
  const { user, loading } = useContext(AuthContext);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen bg-[#101010]">
        <div className="text-white">Loading...</div>
      </div>
    );
  }

  // Check if authenticated
  if (!user) {
    return <Navigate to="/" replace />;
  }

  // ✅ CHECK ROLE AUTHORIZATION
  if (requiredRole && user?.role !== requiredRole) {
    console.warn(`Access denied: Improper authorization permissions`);
    // Redirect to their actual dashboard based on their role
    const dashboardMap = {
      'Owner': '/Odashboard',
      'Trainer': '/edashboard',
      'User': '/customerdashboard'
    };
    return <Navigate to={dashboardMap[user?.role] || '/'} replace />;
  }

  return children;
};

export default ProtectedRoute;